const $ = jQuery.noConflict();
import 'slick-carousel';

'use strict';

/** @description Helper Classes for creating base config options. */
class SliderBaseConfig {
	constructor(slidesToShow = 4, slidesToScroll = 1, speed = 1000, rows = 0) {
		this.slidesToShow = slidesToShow;
		this.slidesToScroll = slidesToScroll;
		this.speed = speed;
		this.rows = rows;
	}
}

const Sliders = {
	/** @description Cache dom and strings. */
	$domSlider: $('.js-slider'),
	$brandSlider: $('.js-brand-slider'),
	$domCircularSlider: $('.js-circular-slider'),
	$testimonialsSlider: $('.js-testimonials-slider'),
	$testimonialsSliderNav: $('.js-slider-nav'),
	$verticalSlider: $('.js-vertical-slider'),
	$verticalSliderNav: $('.js-vertical-slider-nav'),
	$teamSlider: $('.js-team-slider'),

	/** @description Initialize. */
	init: function() {
		this.initSlider();
		this.brandSlider();
		this.initCircularSlider();
		this.testimonialsSlider();
		this.navigationTestimonialsSlider();
		// this.navigationVerticalSlider();
		// this.verticalSlider();
		this.teamSlider();
	},

	// Brend slider
	brandSlider: () => {
		if(Sliders.$brandSlider.length) {
			const numOfSlides = $('.js-brand-slider-item').length;
			if(numOfSlides < 10) {
				$('.js-slider-slide-num').text(`0${numOfSlides}`);
			} else {
				$('.js-slider-slide-num').text(numOfSlides);
			}

		}
		Sliders.$brandSlider.slick({
			infinite: true,
			autoplay: true,
			autoplaySpeed: 3000,
			dots: false,
			slidesToShow: 1,
			variableWidth: true,
			slidesToScroll: 1,
			swipe: true,
			arrows: true,
			prevArrow: '.js-prev',
			nextArrow: '.js-next',
			speed: 500
		});

		Sliders.$brandSlider.on('afterChange', function(event, slick, currentSlider) {
			if(currentSlider < 9) {
				$('.js-slider-counter').text(`0${currentSlider + 1}`);
			} else {
				$('.js-slider-counter').text(currentSlider + 1);
			}
		});
	},

	// Circular slider
	initCircularSlider: () => {
		Sliders.$domCircularSlider.slick({
			infinite: true,
			autoplay: true,
			centerMode: false,
			autoplaySpeed: 3000,
			dots: true,
			slidesToShow: 5,
			variableWidth: true,
			slidesToScroll: 1,
			swipe: true,
			arrows: false,
			speed: 500,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
					},
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 4,
						centerMode: true,
						variableWidth: true,
					},
				},
			],
		});

		//Center slider if less 2 or less slides are present
		const slides = $('.js-circular-slider .slick-slide');

		if(slides.length < 3) {
			$('.js-circular-slider').addClass('center-circular-slider');
		}
	},

	// Testimonials slider
	testimonialsSlider: () => {
		if(Sliders.$testimonialsSlider.length) {
			const numOfSlides = $('.js-testimonials-slider-item').length;
			//console.log(numOfSlides);
			if(numOfSlides < 10) {
				$('.js-slider-testimonials-slide-num').text(`0${numOfSlides}`);
			} else {
				$('.js-slider-testimonials-slide-num').text(numOfSlides);
			}

			//Show arrows if there are only two slides
			if(numOfSlides === 2) {
				$('.js-testimonials-prev, .js-testimonials-next').addClass('arrows-show');
			}else {
				$('.js-testimonials-prev, .js-testimonials-next').removeClass('arrows-show');
			}

		}
		Sliders.$testimonialsSlider.slick({
			infinite: true,
			autoplay: false,
			autoplaySpeed: 2000,
			swipe: true,
			dots: false,
			// fade: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: '.js-testimonials-prev',
			nextArrow: '.js-testimonials-next',
			speed: 500,
			asNavFor: '.js-slider-nav',
			responsive: [
				{
					breakpoint: 991,
					settings: {
						fade: true,
						infinite: true,
						variableWidth: false,
						slidesToShow: 1
					}
				}
			]
		});

		Sliders.$testimonialsSlider.on('afterChange', function(event, slick, currentSlider) {
			if(currentSlider < 9) {
				$('.js-slider-testimonials-counter').text(`0${currentSlider + 1}`);
			} else {
				$('.js-slider-testimonials-counter').text(currentSlider + 1);
			}
		});
	},

	navigationTestimonialsSlider: () => {
		Sliders.$testimonialsSliderNav.slick({
			slidesToShow: 2,
			infinite: true,
			autoplay: false,
			autoplaySpeed: 2000,
			slidesToScroll: 1,
			asNavFor: '.js-testimonials-slider',
			dots: false,
			prevArrow: '.js-testimonials-prev',
			nextArrow: '.js-testimonials-next',
			focusOnSelect: true
		});
	},

	// Vertical slider
	verticalSlider: () => {
		function onSliderAfterChange(event, slick, currentSlide) {
			$(event.target).data('current-slide', currentSlide);
		}

		function onSliderWheel(e) {
			const deltaY = e.originalEvent.deltaY;
			const $currentSlider = $(e.currentTarget);
			const currentSlickIndex = $currentSlider.data('current-slide') || 0;
			if ((deltaY < 0 && currentSlickIndex === 0) ||
				(deltaY > 0 && currentSlickIndex === $currentSlider.data('slider-length') - 1)) {
				return;
			}

			e.preventDefault();
			if (e.originalEvent.deltaY < 0) {
				$currentSlider.slick('slickPrev');
			} else {
				$currentSlider.slick('slickNext');
			}
		}

		Sliders.$verticalSlider.each(function(index, element) {
			const $element = $(element);
			$element.data('slider-length', $element.children().length);
		}).slick({
			infinite: false,
			autoplay: false,
			dots: false,
			arrows: false,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
			asNavFor: '.js-vertical-slider-nav'
		})
			.on('afterChange', onSliderAfterChange)
			.on('wheel', onSliderWheel);
	},

	navigationVerticalSlider: () => {
		if(Sliders.$verticalSliderNav.length) {
			const numOfSlides = $('.js-vertical-sliders-item').length;
			if(numOfSlides < 10) {
				$('.js-vertical-slider-slide-num').text(`0${numOfSlides}`);
			} else {
				$('.js-vertical-slider-slide-num').text(numOfSlides);
			}

		}
		Sliders.$verticalSliderNav.slick({
			vertical: true,
			infinite: false,
			autoplay: false,
			dots: false,
			arrows: false,
			speed: 500,
			slidesToShow: 5,
			slidesToScroll: 1,
			focusOnSelect: true,
			asNavFor: '.js-vertical-slider',
			responsive: [
				{
					breakpoint: 991,
					settings: {
						arrows: true,
						prevArrow: '.js-vertical-slider-prev',
						nextArrow: '.js-vertical-slider-next',
						adaptiveHeight: false,
						slidesToShow: 1,
					}
				}
			]
		});

		Sliders.$verticalSliderNav.on('afterChange', function(event, slick, currentSlider) {
			if(currentSlider < 9) {
				$('.js-vertical-slider-counter').text(`0${currentSlider + 1}`);
			} else {
				$('.js-vertical-slider-counter').text(currentSlider + 1);
			}
		});
	},
	// Team slider
	teamSlider: () => {
		if(Sliders.$teamSlider.length) {
			const numOfSlides = $('.js-team-slider-item').length;
			if(numOfSlides < 10) {
				$('.js-slider-team-slide-num').text(`0${numOfSlides}`);
			} else {
				$('.js-slider-team-slide-num').text(numOfSlides);
			}

		}
		Sliders.$teamSlider.slick({
			infinite: true,
			autoplay: false,
			autoplaySpeed: 3000,
			dots: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipe: false,
			fade: true,
			arrows: true,
			prevArrow: '.js-team-slider-prev',
			nextArrow: '.js-team-slider-next',
			speed: 500,
			adaptiveHeight: true
		});

		Sliders.$teamSlider.on('afterChange', function(event, slick, currentSlider) {
			if(currentSlider < 9) {
				$('.js-slider-team-counter').text(`0${currentSlider + 1}`);
			} else {
				$('.js-slider-team-counter').text(currentSlider + 1);
			}
		});
	},

	/** @description Set and run gallery slider. */
	initSlider: function() {
		// create object with base config options
		const baseConfig = new SliderBaseConfig();
		// set extra config options

		const extraConfig = {
			infinite: true,
			autoplay: true,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			speed: 500,
			responsive: [
				{
					breakpoint: 767,
					settings: {
						infinite: true,
						slidesToShow: 1
					}
				}
			]
		};
		// merge two config objects
		const config = {
			...baseConfig,
			...extraConfig
		};
		// run slider
		this.runSlider(this.$domSlider, config);
	},

	/** @description Loop through sliders and run. */
	runSlider: ($slider, config) => {
		$slider.each((i, el) => {
			$(el).slick(config);
		});
	}
};

export default Sliders;
